// extracted by mini-css-extract-plugin
module.exports = {"root":"Notifications_root__2yPLU"};